<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-3 pr-1 mb-2">
                    <month-picker-input v-model="date"></month-picker-input>
                </div>
                <div class="col-3 pl-1 pr-1">
                    <select v-model="bank" v-validate="'required'" name="bank" class="form-control formInput" >
                        <option value="">ব্যাংক সিলেক্ট করুন</option>
                        <option v-for="(bank,key) in bankLists.data" :key="key" :value="bank.id" >{{bank.name}}</option>
                    </select>
                    <p v-show="errors.has('bank')" style="color:red">* Required</p>
                </div>
                <div class="col-3 pl-1 pr-1">
                    <select v-model="report_type" v-validate="'required'" name="report_type" class="form-control formInput" >
                        <option value="">রিপোর্ট টাইপ</option>
                        <option value="summary">সামারি</option>
                        <option value="details">বিস্তারিত</option>
                    </select>
                    <p v-show="errors.has('report_type')" style="color:red">* Required</p>
                </div>
                <div class="col-3 pl-1">
                    <button @click.prevent="getResults()" class="mr-2 btn btn-success my-2 my-sm-0 formInput" >Search</button>
                    <button @click.prevent="download()" class="btn btn-success my-2 my-sm-0 formInput" >Download</button>
                    <a class="btn btn-info float-right" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <div class="details_cont" v-if="this.report_type=='details'">
                <table id="my-table" class="table table-sm mt-3">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">একাউন্ট নম্বর</th>
                            <th scope="col">গ্রাহকের নাম</th>
                            <th scope="col">মোবাইল নম্বর</th>
                            <th scope="col" class="text-center">ওয়ার্ড</th>
                            <th scope="col" class="text-center">পরিমাণ (৳)</th>
                            <th scope="col" class="text-center">স্ট্যাটাস</th>
                            <th scope="col" class="text-center">তৈরি সময়</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(datum,key) in data.data" :key="key">
                            <td>{{key+1}}</td>
                            <td>{{datum.account_no}}</td>
                            <td>{{datum.user_name}}</td>
                            <td>{{datum.mobile_number}}</td>
                            <td class="text-center">{{datum.ward_no}}</td>
                            <td class="text-center">{{thousands_separators(datum.total)}}</td>
                            <td class="text-center">{{datum.status == 0 ?"খেলাপি":""}}{{datum.status == 1 ?"পেইড":""}}{{datum.status == 3 ?"খেলাপি":""}}{{datum.status == 5 ?"আংশিক খেলাপি":""}}</td>
                            <td class="text-center">{{datum.created}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="row">
                    <div class="col-8">
                        <nav aria-label="Page navigation example">
                            <pagination class="mb-0" :limit="5" :data="data" @pagination-change-page="loadContents"></pagination>
                        </nav>
                    </div>
                    <div class="col-4 text-right">
                        <span v-if="all_total">Total : <b>{{ thousands_separators(getFormatedData(all_total)) }}</b></span>
                    </div>
                </div>
            </div>
            <div v-else-if="this.report_type=='summary'">
                <table class="table table-sm mt-3">
                    <thead>
                        <tr>
                            <th scope="col" class="text-center">মাসিক আদায়</th>
                            <th scope="col" class="text-center">বকেয়া আদায়</th>
                            <th scope="col" class="text-center">সারচার্জ</th>
                            <th scope="col" class="text-center">সংযোগ ফি আদায়</th>
                            <th scope="col" class="text-center">মোট আদায়</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-if="values.amount" class="text-center">{{ thousands_separators(values.amount) }}</td>
                            <td v-if="values.due_amount" class="text-center">{{ thousands_separators(values.due_amount) }}</td>
                            <td class="text-center">{{ (values.due_charge>0?thousands_separators(values.due_charge):'') }}</td>
                            <td class="text-center">{{ (values.connection_fee>0?thousands_separators(values.connection_fee):'')}}</td>
                            <td v-if="values.total" class="text-center">{{ thousands_separators(values.total)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { MonthPickerInput } from 'vue-month-picker'
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import axios from "axios";
import pagination from 'laravel-vue-pagination'
import moment from 'moment'
export default {
    data(){
        return {
            date: {
                from: null,
                to: null,
                month: null,
                year: null,
            },
            bank:'',
            report_type:'',
            data:{},
            values:{},
            invoice_type:'water-billing'
        }
    },
    methods:{
        async loadContents(page){
            var start = ''
            var end = ''
            var month = ''
            var year =  ''
            if(this.date.from){
                start = this.date.from
                end = this.date.to
                month = this.date.month
                year = this.date.year
            }

            var data = {
                start,month,year,
                end,
                bank:this.bank,
                report_type:this.report_type,
                invoice_type:this.invoice_type
            }
            //console.log(data);
            axios.post('api/water-bank-wise-collections?page='+page,data).then(response=>{
                //this.report_type = response.data.report_type
                if(this.report_type=='details'){
                    this.data = response.data.bills
                    this.all_total = response.data.all_total
                    this.values = {}
                }else if(this.report_type=='summary'){
                    this.values = response.data
                    this.data = {}
                }
                //console.log(this.values.all_total);
                console.log(this.values);
            })
        },
        async getResults(page = 1){
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.loadContents(page)
                }
            })
        },
        getFormatedData(val) {
            return val.toFixed(2);
        },
        download(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    let getUserInfo = JSON.parse(localStorage.getItem('user'))
                    let loggedUser = getUserInfo.name
                    var start = ''
                    var end = ''
                    var month = ''
                    var year =  ''
                    if(this.date.from){
                        start = this.date.from
                        end = this.date.to
                        month = this.date.month
                        year = this.date.year
                    }
                    //alert(start);
                    var start_date = new Date(start).toLocaleString('en-US', { timeZone: 'Asia/Dhaka'})
                    var end_date = new Date(end).toLocaleString('en-US', { timeZone: 'Asia/Dhaka'})

                    var download = 'download'

                    window.open(`${axios.defaults.baseURL}/api/water-bank-wise-collections?download=${download}&start=${start_date}&end=${end_date}&bank=${this.bank}&month=${month}&year=${year}&invoice_type=${this.invoice_type}&report_type=${this.report_type}&loggeduser=${loggedUser}`)
                }
            })
        },
        thousands_separators(num){
            var num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        },
        getBank(){this.$store.dispatch('BANK_LIST',{page:1});},

    },
    mounted(){
        if(this.$route.name =='পানির বিল রিপোর্ট'){
            this.invoice_type = 'water-billing'
        }
        this.getBank()
    },
    computed:{
        ...mapGetters(['bankLists'])
    },
    components: {
        //VueCtkDateTimePicker,
        pagination,
        MonthPickerInput
    }
}
</script>
<style scoped>
    .formInput{ height: 41px;}
    .date-time-picker label,.card{font-family: 'Hind Siliguri Light' !important; font-size: 16px;}
    .form-control{ font-size: 16px;}
    .btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
</style>
